import i18n from 'services/base/i18n';

export default {
  title: () => i18n.pgettext('Pages|Scanner Tuning', 'SCANNER TUNING'),
  save: () => i18n.pgettext('Pages|Scanner Tuning', 'SAVE'),

  enableScanMdns: () => i18n.pgettext('Pages|Scanner Tuning', 'Enable MDNS Scan'),
  enableScanMdnsHint: () => i18n.pgettext('Pages|Scanner Tuning', 'Attempt to investigate network devices using the MDNS protocol.'),

  enableScanNbios: () => i18n.pgettext('Pages|Scanner Tuning', 'Enable NetBIOS Scan'),
  enableScanNbiosHint: () => i18n.pgettext('Pages|Scanner Tuning', 'Attempt to investigate network devices using the NetBIOS protocol.'),

  enableScanNmap: () => i18n.pgettext('Pages|Scanner Tuning', 'Enable Nmap Scan'),
  enableScanNmapHint: () => i18n.pgettext('Pages|Scanner Tuning', 'Attempt to investigate network devices using the Nmap scanner.'),

  enableScanRdns: () => i18n.pgettext('Pages|Scanner Tuning', 'Enable RDNS Scan'),
  enableScanRdnsHint: () => i18n.pgettext('Pages|Scanner Tuning', 'Attempt to investigate network devices using the RDNS protocol.'),

  enableScanUpnp: () => i18n.pgettext('Pages|Scanner Tuning', 'Enable UPnP Scan'),
  enableScanUpnpHint: () => i18n.pgettext('Pages|Scanner Tuning', 'Attempt to investigate network devices using the UPnP protocol.'),
};
